module.exports = __webpack_public_path__ + "static/r29-ffe6ce0110a548162f29fab6b0c61b18.jpg";